import { Navigate, useLocation } from "react-router-dom";
import { isLogin } from "./token-check";

const PrivateRoute = ({ component: Component, ...rest }) => {
  const location = useLocation();
  const loggedIn = isLogin();

  return loggedIn ? <Component {...rest} /> : <Navigate to={"/"} replace />;
};

export default PrivateRoute;
